<div class="clearfix content">
    <div class="clearfix bi-reponsive">
        <div class="clearfix logout-container" style="background:#F4F7F5;position: fixed;top: 0;right: 0;left: 0;bottom: 0;">
            <div class="clearfix logout-content request  report-filter">
                <br>
                <div>
                    <div class="er-404">
                        <!-- <img src="./assets/images/logo.svg" alt="page not found" class="erLogo"> -->
                        <img src="./assets/images/404-error.svg" alt="Error 404" class="erImg">
                        <p class="sentral bigText">{{'PAGENOTFOUND.Oooops' | translate}}</p>
                        <p class="sentral smallText">{{'PAGENOTFOUND.pageError' | translate}}</p>
                        <button class="btn-primary" *ngIf="!http.loggedIn"  clickable (click)="gotoDashboard()">{{'PAGENOTFOUND.returnHomePage' | translate}}</button>
                    </div>

                </div>

            </div>
        </div>
    </div>
    <!--  <app-footer></app-footer>-->
</div>
